<template>
    <div class="section textCenter">
        <div class="title">
            <h1>Macker Prod <span class="textGradiant">&</span></h1>
            <h1 class="textYellow">Stu'Dee Photographie.</h1>
        </div>
        <div>
            <h4 data-aos="fade-right"
            data-aos-anchor-placement="bottom-bottom"
            data-aos-duration="3000">
            Immortalisez vos plus beaux instants avec un duo passionné. 
            </h4>
            <h4 
            data-aos="fade-left"
            data-aos-anchor-placement="bottom-bottom"
            data-aos-duration="3000">
             Nous racontons votre histoire à travers des souvenirs uniques et intemporels. 
            </h4>
            <h4 data-aos="fade-up"
            data-aos-anchor-placement="bottom-bottom"
            data-aos-duration="3000"
            style="margin-bottom: 20px;">
              Macker Prod et Stu'dee Photographie, deux talents au service de vos émotions.
            </h4>
        </div>
        <!-- <div class="button-container"> -->
            <!-- <button class="down"><a @click.prevent="scrollToSection('video')">DECOUVRIR <Icon icon="material-symbols:arrow-right-alt" /></a></button> -->
            <!-- <button class="up"><a href="#">REGARDER <Icon icon="material-symbols:play-arrow" /></a></button> -->
        <!-- </div> -->
        <div class="video-wrapper">
            
          <video 
          ref="videoPlayer" 
          width="100%" 
          height="100%" 
          autoplay
          muted
          loop 
          playsinline
        >
          <!-- Source locale ou hébergée -->
          <source :src="videoSource" type="video/mp4" />
          <!-- Message si le navigateur ne prend pas en charge la vidéo -->
          Votre navigateur ne supporte pas la vidéo HTML5.
        </video>
    </div>
</div>
    
</template>
<script setup>
import { Icon } from '@iconify/vue';
import { ref  } from 'vue';
import AOS from 'aos';
import 'aos/dist/aos.css';

AOS.init();

const video = ref(null);
const isPlaying = ref(false);
const videoPlayer = ref(null);
// Importer la vidéo locale
const videoSource = new URL('../assets/video/fullHD.mp4', import.meta.url).href;


const togglePlay = () => {
  if (!isPlaying.value) {
    video.value.play();
  } else {
    video.value.pause();
  }
  isPlaying.value = !isPlaying.value;
};

const playVideo = () => {
  video.value.play();
};

const pauseVideo = () => {
  video.value.pause();
};

const scrollToSection = (id) => {
  const section = document.getElementById(id);
  if (section) {
    section.scrollIntoView({ behavior: 'smooth' });
  }
};

</script>
<style lang="scss" scoped>
@import '../assets/main.css';

.section {
    background-color: transparent;
    display: flex;
    gap: 2.5rem;
    flex-direction: column;
    padding: 0 20px;

    .title {
        margin-top: 5rem;
    }
}


.button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    button {
        font-size: 14px;
        border-radius: 26px;
        padding: 8px 16px;
        cursor: pointer;
        font-family: 'Roboto', sans-serif;
        display: flex;
        gap: 6px;
        a {
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          gap: 2px;
        }
    }
}

.video-wrapper {
    position: relative;
    max-width: 1200px;
    width: 100%;
    aspect-ratio: 16/9;
    margin: 0 auto 5REM;
    iframe {
      max-width: 100%;
    }
    video {
      border-radius: 3px;
    }
  }
  
  @media (max-width: 768px) {

    h4 {
        font-size: 14px;
    }
  }

</style>